


















import Vue from 'vue';
import FormField from './FormField.vue';
import ContainRelation from './ContainRelation.vue';
import customerVuex from '../../../vuex/common';
import customerClient from '../../../apis';
import { CustomerFilter, MemberFilter } from '../../../models/CustomerFilter';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    FormField,
    ContainRelation,
  },
  data() {
    return {
      members: [],
    };
  },
  methods: {
    loadMemberCards() {
      customerClient.getMemberCards({}).success(r => {
        this.$data.members = r;
      });
    },
    updateNotIn(notIn: boolean) {
      const v = this.customerFilter.member;
      v.notIn = notIn;
      this.updateMemberFilter(v);
    },
    updateMembers(memberCards: number[]) {
      const v = this.customerFilter.member;
      v.memberIds = memberCards;
      this.updateMemberFilter(v);
    },
    updateMemberFilter(filter: MemberFilter) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'member',
        value: filter,
      });
    },
  },
  mounted() {
    this.loadMemberCards();
  },
});
